<template>
  <section class="hero-section" :class="{ 'is-active': isActive }">
    <!-- 좌측 상단 삼각형 -->
    <div class="corner-triangle"></div>

    <!-- 배경 이미지 (전체) -->
    <div class="hero-bg">
      <img
        class="hero-image"
        src="@/assets/조감도.jpg"
        alt="조감도"
      />
      <!-- 그라데이션 오버레이 -->
      <div class="hero-gradient"></div>
    </div>

    <!-- 중앙 텍스트 -->
    <div class="hero-content">
      <p class="sub-copy">수원의 기준을</p>
      <p class="sub-copy">새롭게 세우다</p>
      <h1 class="main-title">엘리프 한신더휴 수원</h1>
      <div class="badge">분양가 상한제 적용단지</div>
      <p class="open-text">선착순 동호지정 계약중</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  props: {
    isActive: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.hero-section {
  height: 100vh;
  position: relative;
  overflow: hidden;
}

/* 좌측 상단 삼각형 */
.corner-triangle {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 420px 420px 0 0;
  border-color: #b8a99a transparent transparent transparent;
  z-index: 2;
}

/* 배경 이미지 - 전체 영역 */
.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.hero-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 그라데이션 오버레이 (비디오 위에 살짝) */
.hero-gradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
}

/* 중앙 텍스트 */
.hero-content {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 80px;
  text-align: center;
  color: #fff;
}

.sub-copy {
  font-family: var(--font-family3);
  font-size: 40px;
  font-weight: 700;
  letter-spacing: 3px;
  line-height: 1.3;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.7s ease;
}

.hero-section.is-active .sub-copy {
  opacity: 1;
  transform: translateY(0);
}

.hero-section.is-active .sub-copy:nth-child(2) {
  transition-delay: 0.15s;
}

.main-title {
  font-family: var(--font-family);
  font-size: 48px;
  font-weight: 800;
  letter-spacing: -1px;
  margin-top: 20px;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.7s ease 0.3s;
}

.hero-section.is-active .main-title {
  opacity: 1;
  transform: translateY(0);
}

.badge {
  margin-top: 28px;
  padding: 16px 44px;
  border: 2px solid rgba(255, 255, 255, 0.8);
  font-family: var(--font-family);
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.5px;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.7s ease 0.5s;
}

.hero-section.is-active .badge {
  opacity: 1;
  transform: translateY(0);
}

.open-text {
  margin-top: 32px;
  font-family: var(--font-family4);
  font-size: 40px;
  font-weight: 600;
  letter-spacing: 2px;
  margin-top: 2px;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.7s ease 0.8s;
}

.hero-section.is-active .open-text {
  opacity: 1;
  transform: translateY(0);
}

/* Mobile responsive */
@media (max-width: 768px) {
  .hero-section {
    height: 100svh;
    height: 100vh;
    min-height: 560px;
    overflow: hidden;
    max-width: 100vw;
  }

  .corner-triangle {
    border-width: 120px 120px 0 0;
  }

  .hero-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .hero-content {
    padding: 0 24px;
    padding-top: 0;
    justify-content: center;
  }

  .sub-copy {
    font-size: 18px;
    letter-spacing: 1px;
  }

  .main-title {
    font-size: 28px;
    margin-top: 12px;
    letter-spacing: -0.5px;
  }

  .badge {
    margin-top: 16px;
    padding: 8px 20px;
    font-size: 14px;
    border-width: 1.5px;
  }

  .open-text {
    font-size: 18px;
    letter-spacing: 1px;
    margin-top: 16px;
  }
}
</style>
